import './CopyToClipboardNotification.scss';

import {useEffect, useState} from 'react';
import Icon, {IconSizes} from '../icon/Icon';
import {Events, EventType} from '../../events/Events';
import {delay, DelayResult} from '../../utils/Timing';

let currentTimeout: DelayResult|undefined;

const CopyToClipboardNotification = () => {
  const [notificationLabel, setNotificationLabel] = useState<string>();

  useEffect(() => {
    Events.subscribe(EventType.COPY_TO_CLIPBOARD_NOTIFICATION, (label: string) => {
      setNotificationLabel(label);

      currentTimeout?.cancel();
      currentTimeout = delay(1500, () => {
        setNotificationLabel(undefined);
        currentTimeout = undefined;
      });
    });
  }, []);

  if (notificationLabel == null) {
    return null;
  }

  return <div className='copy-to-clipboard-notification'>
    <div className='copy-to-clipboard-notification-icon'>
      <Icon category='fa-regular fa-copy' size={IconSizes.LARGE}/>
    </div>
    <div className='copy-to-clipboard-notification-label'>{notificationLabel}</div>
  </div>;
}

export default CopyToClipboardNotification;
